module.exports = __webpack_public_path__ + "img/thumbnail_KingPenguin_m_normal.c3868eef.png";